import React from "react";
import Slider from "react-slick";
import LeftArrowIcon from "../assets/icons/Prevarrow.png";
import RightArrowIcon from "../assets/icons/Nextarrow.png";
import KekaLogo from "../assets/icons/Keka.png";
import PeopleStrongLogo from "../assets/icons/PeopleStrong.png";
import SAPLogo from "../assets/icons/SAP.png";
import WorkdayLogo from "../assets/icons/Workday.png";
import IcimsLogo from "../assets/icons/ICIMS.png";
import GreytHRLogo from "../assets/icons/GreytHR.png";
import DarwinBoxLogo from "../assets/icons/DarwinBox.png";
import ZohoLogo from "../assets/icons/Zoho.png";
import { Button } from "@mui/material";
import { TechPartnersArrowButton, TechPartnersDesktopGrid, TechPartnersDivider, TechPartnersLogoImage, TechPartnersMobileSliderContainer, TechPartnersRow, TechPartnersSectionContainer, TechPartnersSubtitle, TechPartnersTitle } from "../assets/styles/CommonStyles";
import { useNavigate } from "react-router-dom";

const logos = [
  [KekaLogo,SAPLogo, PeopleStrongLogo, WorkdayLogo, IcimsLogo],
  [GreytHRLogo, DarwinBoxLogo, ZohoLogo],
];

const TechPartnersNextArrow = ({ onClick }) => (
  <TechPartnersArrowButton src={RightArrowIcon} onClick={onClick} style={{ right: "2vw" }} />
);

const TechPartnersPrevArrow = ({ onClick }) => (
  <TechPartnersArrowButton src={LeftArrowIcon} onClick={onClick} style={{ left: "2vw" }} />
);

const TechnologyPartnersSection = () => {
    const navigate = useNavigate();
  
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    nextArrow: <TechPartnersNextArrow />,
    prevArrow: <TechPartnersPrevArrow />,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };
  
  return (
    <TechPartnersSectionContainer>
      <TechPartnersTitle>Excellence through integration</TechPartnersTitle>
      <TechPartnersSubtitle>
        See how businesses like yours are transforming safety with iScreening. Our clients personalize risk
        assessments, focusing on what matters most to them.
      </TechPartnersSubtitle>
      <TechPartnersDesktopGrid>
        {logos.map((row, rowIndex) => (
          <TechPartnersRow key={rowIndex}>
            {row.map((logo, index) => (
              <React.Fragment key={index}>
                <TechPartnersLogoImage src={logo} alt="Partner Logo" />
                {index < row.length - 1 && <TechPartnersDivider />}
              </React.Fragment>
            ))}
          </TechPartnersRow>
        ))}
      </TechPartnersDesktopGrid>

      <TechPartnersMobileSliderContainer>
        <Slider {...settings}>
          {logos.flat().map((logo, index) => (
            <TechPartnersLogoImage key={index} src={logo} alt={`Partner Logo ${index}`} />
          ))}
        </Slider>
      </TechPartnersMobileSliderContainer>

      <Button className="custom-button" variant="contained"  onClick={() => navigate("/contact-us")} >Get Demo</Button>
    </TechPartnersSectionContainer>
  );
};

export default TechnologyPartnersSection;
